export const allPropertyItemSearch = (item, search /*, filter*/) => {
  for (let property in item) {
    if (item[property] != null && typeof item[property].toString() === "string") {
      if (
        item[property]
          .toString()
          .toUpperCase()
          .search(search.toUpperCase()) != -1
      ) {
        return true;
      }
    }
    if (typeof item[property] === "object") {
      if (allPropertyItemSearch(item[property], search)) {
        return true;
      }
    }
  }
  return false;
};

export default function(value, search, item) {
  return allPropertyItemSearch(item, search);
}
